import { useState } from "react";

export type PrevScoresState = {
    setPrevScores: (prevScores: boolean | undefined) => void;
};

type PrevScoresParams = {
    query: boolean | undefined;
    state: PrevScoresState;
};
export const usePrevScores = (initPrevScores?: boolean): PrevScoresParams => {
    const [prevScores, setPrevScores] = useState<boolean | undefined>(initPrevScores);

    return {
        query: prevScores,
        state: {
            setPrevScores,
        },
    };
};
